export type MatchingFieldType = 'alias' | 'email' | 'phone';

export interface MatchingConditionGroup {
  and: MatchingFieldType[];
}

export interface MatchingRules {
  v1: {
    or: MatchingConditionGroup[];
  };
}

export const FIELD_DISPLAY_LABELS: Record<MatchingFieldType, string> = {
  alias: 'Name',
  email: 'Email',
  phone: 'Phone number',
};
